import { RBIEnv, env, isLocalDev } from 'utils/environment';

// this must be defined statically because at app start we don't have values from launchdarkly yet.
export const SESSION_SAMPLE_RATE = isLocalDev || env() !== RBIEnv.PROD ? 100 : 5;
